(() => {
  if (customElements.get('tg26-price-offer')) return;
  class ThanksgivingPriceOffer extends HTMLElement {
    connectedCallback() {
      try {
        this.config = JSON.parse(this.querySelector('[data-tg26-config]').textContent);
        this.host = this.closest('product-info');
        this.selectedId = String(this.config.selectedVariantId);
        this.amount = this.querySelector('[data-tg26-price]');
        this.copyButton = this.querySelector('[data-tg26-copy]');
        this.copyStatus = this.querySelector('[data-tg26-status]');
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: this.config.currency
        });
        this.onChange = (event) => {
          if (event.target.matches('input[name="id"]')) {
            this.selectedId = String(event.target.value);
            this.refresh();
          } else if (event.target.closest('variant-selects, variant-radios')) {
            // Hide the previous variant's offer while Shopify fetches the next price.
            this.hidden = true;
          }
        };
        this.onVariant = (event) => {
          if (String(event?.data?.sectionId) !== String(this.config.sectionId)) return;
          this.selectedId = event.data.variant ? String(event.data.variant.id) : '';
          this.refresh();
        };
        this.onVisibility = () => this.refresh();
        this.onCopy = async () => {
          if (this.hidden) return;
          let copied = false;
          try {
            await navigator.clipboard.writeText(this.config.code);
            copied = true;
          } catch (_) {
            const field = document.createElement('textarea');
            field.value = this.config.code;
            field.setAttribute('readonly', '');
            field.style.cssText = 'position:fixed;left:-9999px;top:0';
            document.body.append(field);
            field.select();
            copied = document.execCommand('copy');
            field.remove();
            this.copyButton.focus({ preventScroll: true });
          }
          this.copyStatus.textContent = copied ? 'Code copied' : `Copy code: ${this.config.code}`;
          this.copyButton.setAttribute('aria-label', copied ? `Discount code ${this.config.code} copied` : `Copy discount code ${this.config.code}`);
          clearTimeout(this.feedbackTimer);
          this.feedbackTimer = setTimeout(() => { this.copyStatus.textContent = ''; }, 3000);
        };
        this.host?.addEventListener('change', this.onChange);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.copyButton.addEventListener('click', this.onCopy);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant);
        }
        this.refresh();
      } catch (_) {
        this.hidden = true;
      }
    }
    refresh() {
      clearTimeout(this.boundaryTimer);
      const now = Date.now();
      const start = Date.parse(this.config.startsAt);
      const end = Date.parse(this.config.endsAt);
      const variant = this.config.variants.find(v => String(v.id) === this.selectedId);
      const active = Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
      if (variant && Number.isInteger(variant.price) && variant.price >= 0) {
        // Work in integer minor currency units; the offer is per selected item.
        const discounted = Math.round(variant.price * (10000 - this.config.discountBps) / 10000);
        this.amount.textContent = this.formatter.format(discounted / 100);
        this.dataset.variantId = this.selectedId;
        this.dataset.priceMinor = String(discounted);
        this.hidden = !active;
      } else {
        this.hidden = true;
      }
      const next = now < start ? start : (now < end ? end : null);
      if (next !== null) this.boundaryTimer = setTimeout(() => this.refresh(), Math.min(next - now + 1, 2147483647));
    }
    disconnectedCallback() {
      this.host?.removeEventListener('change', this.onChange);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.copyButton?.removeEventListener('click', this.onCopy);
      this.unsubscribe?.();
      clearTimeout(this.boundaryTimer);
      clearTimeout(this.feedbackTimer);
    }
  }
  customElements.define('tg26-price-offer', ThanksgivingPriceOffer);
})();
